var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"auth"}},[_c('div',{staticClass:"logo"},[_c('inline-svg',{attrs:{"src":require('../../assets/logo.svg')}})],1),_c('div',{staticClass:"card"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }